import type { Writing } from "./types";

const writing: Writing = {
  slug: "japanese-colors",
  title: "Experimenting with Japanese colors",
  date: "2026",
  status: "WIP",
  description: "Coming soon",
  placeholder: [],
};

export default writing;
